import { Box, Fade, Modal, useTheme, Button } from "@mui/material"
import { deepmerge } from "@mui/utils"
import { Image } from "components/Image"

import { useTranslation } from "providers/i18n"

export const TransportationImageModal = ({
  open = false,
  imageSrc,
  alt = "image",
  onClose,
  fadeProps = {},
  sx = {},
  ...props
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const styleOverrides =
    theme.components[`TransportationImageModal`]?.styleOverrides || {}
  const { root, imageWrapper, image, closeButton } = styleOverrides

  return (
    <Modal sx={deepmerge(root, sx)} open={open} onClose={onClose} {...props}>
      <Fade in={open} timeout={500} {...fadeProps}>
        <Box sx={imageWrapper}>
          <Image sx={image} src={imageSrc} alt={alt} />
          <Button onClick={onClose} sx={closeButton} variant="contained">
            {t("Close")}
          </Button>
        </Box>
      </Fade>
    </Modal>
  )
}
